import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Teste from "../pages/teste/page";
import ResultadoBloqueado from "../pages/resultado-bloqueado/page";
import Checkout from "../pages/checkout/page";
import Resultado from "../pages/resultado/page";
import Admin from "../pages/admin/page";
import Account from "../pages/Account";
import Acesso from "../pages/acesso/page";
import PaidRoute from "../components/feature/PaidRoute";

const routes: RouteObject[] = [
  { path: "/minha-conta", element: <Account /> },
  { path: "/acesso", element: <Acesso /> },
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/teste",
    element: <PaidRoute><Teste /></PaidRoute>,
  },
  {
    path: "/resultado-bloqueado",
    element: <ResultadoBloqueado />,
  },
  {
    path: "/checkout",
    element: <Checkout />,
  },
  {
    path: "/resultado",
    element: <PaidRoute><Resultado /></PaidRoute>,
  },
  {
    path: "/admin",
    element: <Admin />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
